// Code review - In Progress
// Documentation - In Progress
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import Loader from "../ReusableComponents/Loader";
import { BindAPI } from "../services/APIConnection";



const InvitePartnerPopup = forwardRef((props, ref) => {
  const [VCPartner, setVCPartner] = useState("");
  const [VCPContPersonFirstName, setVCPContPersonFirstName] = useState("");
  const [VCPContPersonLastName, setVCPContPersonLastName] = useState("");
  const [VCPContPersonPosition, setVCPContPersonPosition] = useState("");
  const [VCPContPersonEmail, setVCPContPersonEmail] = useState("");
  const [VCPContPersonMobile, setUpStrContPersonMobile] = useState("");
  const [company, setCompany] = useState("");
  const [companyInvPersonFirstName, setCompanyInvPersonFirstName] =
    useState("");
  const [companyInvPersonLastName, setCompanyInvPersonLastName] = useState("");
  const [companyInvPersonPosition, setCompanyInvPersonPosition] = useState("");
  const [companyInvPersonEmail, setCompanyInvPersonEmail] = useState("");
  const [companyInvPersonMobile, setCompanyInvPersonMobile] = useState("");
  const [errors, setErrors] = useState({});
  const [bindInvitePartner, setBindInvitePartner] = useState([]);



  const handleBlur = (field, value) => {
    if (field === "VCPContPersonMobile" || field === "companyInvPersonMobile")
      return; // Skip validation
    if (!value || value.trim() === "") {
      setErrors((prev) => ({ ...prev, [field]: "This field is required" }));
    }
    
    if (field.toLowerCase().includes("email")) {
      // const emailRegex = /^[A-Za-z0-9._-]+@[A-Za-z]+\.[A-Za-z]{2,}$/;
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // if (value && !emailRegex.test(value)) {
      //   setErrors((prev) => ({ ...prev, [field]: "Invalid email format" }));
      // }
    }
  };

  const handleChange = (field, setter, value) => {
    setter(value);
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  useImperativeHandle(ref, () => ({
    validateAndGetFormData: () => {
      const formData = {
        VCPartner,
        VCPContPersonFirstName,
        VCPContPersonLastName,
        VCPContPersonPosition,
        VCPContPersonEmail,
        VCPContPersonMobile,
        company,
     //   companyInvPersonFirstName,
    //    companyInvPersonLastName,
    //    companyInvPersonPosition,
        companyInvPersonEmail,
        companyInvPersonMobile,
      };

      const newErrors = {};
      const emailRegex = /^[A-Za-z0-9._-]+@[A-Za-z]+\.[A-Za-z]{2,}$/;

      for (let [key, value] of Object.entries(formData)) {
        if (
          key !== "VCPContPersonMobile" &&
          key !== "companyInvPersonMobile" &&
          (!value || value.trim() === "")
        ) {
          newErrors[key] = "This field is required";
        }
      }

      // if (VCPContPersonEmail && !emailRegex.test(VCPContPersonEmail)) {
      //   newErrors.VCPContPersonEmail = "Invalid email format";
      // }

      if (VCPContPersonEmail) {
        const trimmedEmail = VCPContPersonEmail.trim().toLowerCase();

        // if (!emailRegex.test(trimmedEmail)) {
          if (false) {
          newErrors.VCPContPersonEmail = "Invalid email format";
        } else {
          // ✅ Check if the email already exists in bindInvitePartner
          const isDuplicate = bindInvitePartner?.some(
            (item) => item?.VCPEmail?.trim().toLowerCase() === trimmedEmail
          );

          if (isDuplicate) {
            newErrors.VCPContPersonEmail = "This email already exists";
          }
        }
      }

      // if (companyInvPersonEmail && !emailRegex.test(companyInvPersonEmail)) {
      //   newErrors.companyInvPersonEmail = "Invalid email format";
      // }

      // ✨ Check: VCPartner and company must not be same
      if (
        VCPartner.trim().toLowerCase() === company.trim().toLowerCase() &&
        VCPartner.trim() !== ""
      ) {
        newErrors.VCPartner = "Value Chain Partner and Company cannot be the same";
        newErrors.company = "Company and Value Chain Partner cannot be the same";
      }

      // ✨ Check: VCPContPersonEmail and companyInvPersonEmail must not be same
      if (
        VCPContPersonEmail.trim().toLowerCase() === companyInvPersonEmail.trim().toLowerCase() &&
        VCPContPersonEmail.trim() !== ""
      ) {
        newErrors.VCPContPersonEmail = "This email must be different from Company Contact Email";
        newErrors.companyInvPersonEmail = "This email must be different from Value Chain Partner Contact Email";
      }

      if (
        VCPContPersonMobile.trim() !== "" &&
        companyInvPersonMobile.trim() !== "" &&
        VCPContPersonMobile.trim() === companyInvPersonMobile.trim()
      ) {
        newErrors.VCPContPersonMobile = "Mobile numbers cannot be the same";
        newErrors.companyInvPersonMobile = "Mobile numbers cannot be the same";
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length > 0) {
        return { success: false, message: "Validation failed" };
      }

      return { success: true, data: formData };
    },


    clearFormData: () => {
      setVCPartner("");
      setVCPContPersonFirstName("");
      setVCPContPersonLastName("");
      setVCPContPersonPosition("");
      setVCPContPersonEmail("");
      setUpStrContPersonMobile("");
      setCompany("");
      setCompanyInvPersonFirstName("");
      setCompanyInvPersonLastName("");
      setCompanyInvPersonPosition("");
      setCompanyInvPersonEmail("");
      setCompanyInvPersonMobile("");
      setErrors({});
    },
  }));

  const handleMobileValidation = () => {
    if (
      VCPContPersonMobile.trim() !== "" &&
      companyInvPersonMobile.trim() !== "" &&
      VCPContPersonMobile.trim() === companyInvPersonMobile.trim()
    ) {
      setErrors((prev) => ({
        ...prev,
        VCPContPersonMobile: "Mobile numbers cannot be the same",
        companyInvPersonMobile: "Mobile numbers cannot be the same",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        VCPContPersonMobile: "",
        companyInvPersonMobile: "",
      }));
    }
  };
  useEffect(() => {
    
    const fetchData = async () => {
      const response = await BindAPI("MasterDataAPI/BindDDValues");
      const resultdata = response.data.Table1;
      setBindInvitePartner(resultdata);
    };
    console.log(bindInvitePartner)
    fetchData();
  }, []);

  return (
    <div className="w-full">
      <Loader
        isVisible={props.isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div className={mainTable.mainContentScreen}>
        <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
          <div className={mainTable.label}>Value Chain Partner Details</div>
          <hr className={mainTable.horizontalLine} />
          <div className="grid gap-4 mb-6 md:grid-cols-3">
            <InputText
              inputType="text"
              title="Name of the partner organization"
              name="VCPartner"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/;

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange("VCPartner", setVCPartner, inputVal);
                // }
              }}
              controlFuncBlur={() => {
                handleBlur("VCPartner", VCPartner);

                // Check if both fields have the same value
                if (VCPartner.trim() === company.trim() && VCPartner.trim() !== "") {
                  setErrors((prev) => ({
                    ...prev,
                    VCPartner: "Value Chain Partner cannot be the same as Your Company",
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    VCPartner: "",
                  }));
                }
              }}
              content={VCPartner}
              maxLength={100}
              classStar="text-red-500"
              errorMessage={errors.VCPartner}
            
            />
            <InputText
              inputType="text"
              title="Contact Person First Name"
              name="VCPContPersonFirstName"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "VCPContPersonFirstName",
                    setVCPContPersonFirstName,
                    inputVal
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur("VCPContPersonFirstName", VCPContPersonFirstName)
              }
              content={VCPContPersonFirstName}
              maxLength={50}
              classStar="text-red-500"
              errorMessage={errors.VCPContPersonFirstName}
          
            />
            <InputText
              inputType="text"
              title="Contact Person Last Name"
              name="VCPContPersonLastName"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "VCPContPersonLastName",
                    setVCPContPersonLastName,
                    inputVal
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur("VCPContPersonLastName", VCPContPersonLastName)
              }
              content={VCPContPersonLastName}
              maxLength={50}
              classStar="text-red-500"
              errorMessage={errors.VCPContPersonLastName}
              
            />
            <InputText
              inputType="text"
              title="Designation"
              name="VCPContPersonPosition"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "VCPContPersonPosition",
                    setVCPContPersonPosition,
                    inputVal
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur("VCPContPersonPosition", VCPContPersonPosition)
              }
              content={VCPContPersonPosition}
              maxLength={100}
              classStar="text-red-500"
              errorMessage={errors.VCPContPersonPosition}
             
            />

            {/* <InputText
              inputType="text"
              title="Email"
              name="VCPContPersonEmail"
              maxLength={150}
              controlFunc={(e) =>
                handleChange("VCPContPersonEmail", setVCPContPersonEmail, e.target.value)
              }
              controlFuncBlur={() => {
                handleBlur("VCPContPersonEmail", VCPContPersonEmail);

                if (
                  VCPContPersonEmail.trim().toLowerCase() ===
                  companyInvPersonEmail.trim().toLowerCase() &&
                  VCPContPersonEmail.trim() !== ""
                ) {
                  setErrors((prev) => ({
                    ...prev,
                    VCPContPersonEmail:
                      "This email cannot be the same as the company contact email",
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    VCPContPersonEmail: "",
                  }));
                }
              }}
              content={VCPContPersonEmail}
              classStar="text-red-500"
              errorMessage={errors.VCPContPersonEmail}
            /> */}

            <InputText
              inputType="text"
              title="Email"
              name="VCPContPersonEmail"
              maxLength={150}
              controlFunc={(e) =>
                handleChange("VCPContPersonEmail", setVCPContPersonEmail, e.target.value)
              }
              controlFuncBlur={() => {
                handleBlur("VCPContPersonEmail", VCPContPersonEmail);

                const trimmedEmail = VCPContPersonEmail.trim().toLowerCase();
// ✅ Check if it already exists in bindInvitePartner
                const isDuplicate = bindInvitePartner?.some(
                  (item) =>
                    item?.VCPEmail?.trim().toLowerCase() === trimmedEmail
                );
                // Check if it matches company contact email
                if (
                  trimmedEmail === companyInvPersonEmail.trim().toLowerCase() &&
                  trimmedEmail !== ""
                ) {
                  setErrors((prev) => ({
                    ...prev,
                    VCPContPersonEmail: "This email cannot be the same as the company contact email",
                  }));
                  return;
                }

                

                // else if (isDuplicate) {
                //   setErrors((prev) => ({
                //     ...prev,
                //     VCPContPersonEmail: "This email already exists",
                //   }));
                // } 
                else if (trimmedEmail === "") {
                    setErrors((prev) => ({  
                      ...prev,
                      VCPContPersonEmail: "This field is required",
                    }));
                  }
                // else if (!/^[A-Za-z0-9._-]+@[A-Za-z]+\.[A-Za-z]{2,}$/.test(trimmedEmail)) {
                //   setErrors((prev) => ({  
                //     ...prev,
                //     VCPContPersonEmail: "Invalid email format",
                //   }));
                // }
                  
                else {
                  setErrors((prev) => ({
                    ...prev,
                    VCPContPersonEmail: "",
                  }));
                }
              }}
              content={VCPContPersonEmail}
              classStar="text-red-500"
              errorMessage={errors.VCPContPersonEmail}
            
            />

            <InputText
              inputType="text"
              title="Mobile"
              name="VCPContPersonMobile"
              maxLength={15}
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyNumbersRegex = /^[0-9\s+\-()]*$/;

                if (onlyNumbersRegex.test(inputVal)) {
                  setUpStrContPersonMobile(inputVal);
                }
              }}
              controlFuncBlur={handleMobileValidation}
              content={VCPContPersonMobile}
              errorMessage={errors.VCPContPersonMobile}
            
            />

          </div>

          <div className={mainTable.label}>Your Company Details</div>
          <hr className={mainTable.horizontalLine} />
          <div className="grid gap-4 mb-6 md:grid-cols-3">
            <InputText
              inputType="text"
              title="Your company name"
              name="company"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s-]*$/;

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange("company", setCompany, inputVal);
                // }
              }}
              controlFuncBlur={() => {
                handleBlur("company", company);

                // Check if both fields have the same value
                if (company.trim() === VCPartner.trim() && company.trim() !== "") {
                  setErrors((prev) => ({
                    ...prev,
                    company: "Your Company cannot be the same as Value Chain Partner",
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    company: "",
                  }));
                }
              }}
              content={company}
              maxLength={100}
              classStar="text-red-500"
              errorMessage={errors.company}
              
            />
            <InputText
              inputType="text"
              title="Contact Person First Name"
              maxLength={50}
              name="companyInvPersonFirstName"
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "companyInvPersonFirstName",
                    setCompanyInvPersonFirstName,
                    inputVal
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur(
                  "companyInvPersonFirstName",
                  companyInvPersonFirstName
                )
              }
              content={companyInvPersonFirstName}
              
            />
            <InputText
              inputType="text"
              title="Contact Person Last Name"
              name="companyInvPersonLastName"
              maxLength={50}
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "companyInvPersonLastName",
                    setCompanyInvPersonLastName,
                    e.target.value
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur("companyInvPersonLastName", companyInvPersonLastName)
              }
              content={companyInvPersonLastName}
              
              
            />
            <InputText
              inputType="text"
              title="Designation"
              name="companyInvPersonPosition"
              maxLength={100}
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                // if (onlyLettersRegex.test(inputVal)) {
                  handleChange(
                    "companyInvPersonPosition",
                    setCompanyInvPersonPosition,
                    e.target.value
                  );
                // }
              }}
              controlFuncBlur={() =>
                handleBlur("companyInvPersonPosition", companyInvPersonPosition)
              }
              content={companyInvPersonPosition}
             
            
            />
            <InputText
              inputType="text"
              title="Email"
              name="companyInvPersonEmail"
              maxLength={150}
              controlFunc={(e) =>
                handleChange("companyInvPersonEmail", setCompanyInvPersonEmail, e.target.value)
              }
              controlFuncBlur={() => {
                handleBlur("companyInvPersonEmail", companyInvPersonEmail);

                const trimmedEmail = companyInvPersonEmail.trim().toLowerCase();
// ✅ Check if it already exists in bindInvitePartner
                // const isDuplicate = bindInvitePartner?.some(
                //   (item) =>
                //     item?.VCPEmail?.trim().toLowerCase() === trimmedEmail
                // );

                if (
                  companyInvPersonEmail.trim().toLowerCase() ===
                  VCPContPersonEmail.trim().toLowerCase() &&
                  companyInvPersonEmail.trim() !== ""
                ) {
                  setErrors((prev) => ({
                    ...prev,
                    companyInvPersonEmail:
                      "This email cannot be the same as the value chain partner email",
                  }));
                } 
                // else if (isDuplicate) {
                //   setErrors((prev) => ({
                //     ...prev,
                //     companyInvPersonEmail: "This email already exists",
                //   }));
                // }
                else if (trimmedEmail === "") {
                  setErrors((prev) => ({
                    ...prev,
                    companyInvPersonEmail: "This field is required",
                  }));
                }  
                // else if (!/^[A-Za-z0-9._-]+@[A-Za-z]+\.[A-Za-z]{2,}$/.test(trimmedEmail)) {
                //   setErrors((prev) => ({
                //     ...prev,
                //     companyInvPersonEmail: "Invalid email format",
                //   }));
                // }               
                
                else {
                  setErrors((prev) => ({
                    ...prev,
                    companyInvPersonEmail: "",
                  }));
                }
              }}
              content={companyInvPersonEmail}
              classStar="text-red-500"
              errorMessage={errors.companyInvPersonEmail}
             
            />


            <InputText
              inputType="text"
              title="Mobile"
              name="companyInvPersonMobile"
              maxLength={15}
              controlFunc={(e) => {
                const inputVal = e.target.value;
                const onlyNumbersRegex = /^[0-9\s+\-()]*$/;

                if (onlyNumbersRegex.test(inputVal)) {
                  setCompanyInvPersonMobile(inputVal);
                }
              }}
              controlFuncBlur={handleMobileValidation}
              content={companyInvPersonMobile}
              errorMessage={errors.companyInvPersonMobile}
             
            />

          </div>
        </form>
      </div>
    </div>
  );
});




export default InvitePartnerPopup;
